import { Mark } from "../brand/Logo";
import { useSite } from "../../lib/site";

const Group = ({ items, hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`whitespace-nowrap px-6 font-display text-5xl font-semibold uppercase tracking-[-0.03em] sm:text-7xl lg:text-8xl ${
            i % 2 ? "outline-text text-ink" : "text-ink"
          }`}
        >
          {item}
        </span>
        <Mark className="h-10 w-10 sm:h-14 sm:w-14" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { content } = useSite();
  const items = content.marquee.items;
  return (
    <section className="relative overflow-hidden border-b border-ink/10 bg-paper py-10 sm:py-14" data-testid="editorial-marquee" aria-label="Conceptos de marca">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        <Group items={items} />
        <Group items={items} hidden />
      </div>
    </section>
  );
};
